/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.12.17.
 */

import _ from "underscore";
import QueryParamParser from "./QueryParamParser";
import ParamParser from "./ParamParser";

class RestrictionCalculator {

    constructor(params, data) {
        this.params = params;
        this.data = data;
        this.paramParser = new ParamParser(params, data);
    }

    /**
     * Calculates restriction expression and returns true if expression is satisfied.
     * Restriction is an expression in the form:
     *  {name}{op}{value}&...
     * Where:
     *  name - parameter name or data field name
     *  op - operator, one of:
     *      "" - equal
     *      "=" - equal or null if value is not present
     *      "!" - not equal
     *      "!=" - not equal or not null if value is not present
     *      ">" - greater than
     *      ">=" - greater than or equal
     *      "<" - less than
     *      "<=" - less than or equal
     *      "%" - contains
     *  value - allowed value
     * If there are multiple expressions with the same name then those expressions are OR-ed together, all other expressions are AND-ed together
     * @param {string} restriction Restriction as query string
     * @returns {boolean}
     */
    isSatisfied(restriction) {
        if (restriction == null) return true;

        let expr = QueryParamParser.parseAsObject(restriction);
        for (let field of _.keys(expr)) {
            let item = expr[field];
            if (!_.isArray(item)) item = [expr[field]];

            let satisfied = false;
            for (let i of item) {
                if (this.isTrue(field, i.op, i.value)) {
                    satisfied = true;
                    break;
                }
            }
            if (!satisfied) return false;
        }
        return true;
    }

    /**
     * @private
     * @param field
     * @param op
     * @param value
     * @returns {boolean}
     */
    isTrue(field, op, value) {
        let formattedValue = this.paramParser.formatValue(value);
        let fieldValue = this.getFieldValue(field);
        switch (op) {
            case "":
                // Equal or ignore if empty:
                if (formattedValue == null || formattedValue == "") return true;
            case "=":
                if (fieldValue == formattedValue) return true;
                return false;
            case "!":
                // Not equal or ignore if empty:
                if (formattedValue == null || formattedValue == "") return true;
            case "!=":
                if (fieldValue != formattedValue) return true;
                return false;
            case ">":
                if (formattedValue == null || formattedValue == "") return true;
                if (fieldValue > formattedValue) return true;
                return false;
            case ">=":
                if (formattedValue == null || formattedValue == "") return true;
                if (fieldValue >= formattedValue) return true;
                return false;
            case "<":
                if (formattedValue == null || formattedValue == "") return true;
                if (fieldValue < formattedValue) return true;
                return false;
            case "<=":
                if (formattedValue == null || formattedValue == "") return true;
                if (fieldValue <= formattedValue) return true;
                return false;
            case "%":
                if (formattedValue == null || formattedValue == "") return true;
                if (fieldValue == null || fieldValue == "") return true;
                if (formattedValue.toLowerCase().indexOf(fieldValue.toLowerCase()) >= 0) return true;
                return false;
            default:
                return false;
        }
    }

    getFieldValue(field) {
        if (this.params && _.has(this.params, field)) return this.params[field];
        if (this.data && _.has(this.data, field)) return this.data[field];
        return null;
    }

}

export default RestrictionCalculator;
